module.exports = __webpack_public_path__ + "img/no_data.0d84a1ac.png";